import { Component, Input, OnInit } from '@angular/core';
import { ActivatedRoute, Params, Router } from '@angular/router';
import { HisAuthService, HisNavigationService } from 'hisng';
import { RightsUtils } from '../../../common/utils/rights-utils';
import { ResearchInfrastructure } from '../../model/research-infrastructure';
import { ResearchInfrastructureOrganisation } from '../../model/research-infrastructure-classes';
import { ResearchInfrastructureService } from '../../service/research-infrastructure.service';

@Component({
    selector: 'res-infrastructure-view-details',
    templateUrl: './research-infrastructure-view-details.component.html',
})
export class ResearchInfrastructureViewDetailsComponent implements OnInit {

    @Input() researchInfrastructure: ResearchInfrastructure = new ResearchInfrastructure();
    private selectedResearchInfrastructureId: number;

    public showEditButton = true;
    public hasEditRights = false;
    public showBackButton = false;
    public showSearchButton = true;
    public showParentLink = true;
    public dateFormat: string;
    public personRights: Map<number, boolean> = new Map<number, boolean>();
    public filteredOperators: ResearchInfrastructureOrganisation[] = [];
    public filteredCoordinators: ResearchInfrastructureOrganisation[] = [];

    constructor( private route: ActivatedRoute,
        private router: Router,
        public rights: RightsUtils,
        public auth: HisAuthService,
        private navigationService: HisNavigationService,
        private researchInfrastructureService: ResearchInfrastructureService
    ) {
    }

    ngOnInit() {
        this.route.params.subscribe( ( paramMap: Params)  => {
            this.selectedResearchInfrastructureId = parseInt(paramMap.id, 10);
            this.researchInfrastructureService.canEditResearchInfrastructure(this.selectedResearchInfrastructureId).subscribe(
                ( hasEditRights: boolean ) => this.hasEditRights = hasEditRights );
            this.initView();
        });
        // read parameters - back button and edit button
        this.route.queryParams.subscribe( ( queryParams: Params ) => {
            this.showEditButton = queryParams.showEditButton ? queryParams.showEditButton === 'true' : this.showEditButton;
            this.showBackButton = queryParams.showBackButton ? queryParams.showBackButton === 'true' : this.showBackButton;
            this.showSearchButton = queryParams.showSearchButton ? queryParams.showSearchButton === 'true' : this.showSearchButton;
        });
    }


    /*
     * Method to initialize the detail view of researchInfrastructure.
     * Reads the researchInfrastructure from the database
     * Necessary to allow reload of view if researchInfrastructure id is changed.
     */
    private initView() {
        this.researchInfrastructureService.getResearchInfrastructureWithDetailsById(this.selectedResearchInfrastructureId).subscribe(
            ( researchInfrastructure: ResearchInfrastructure ) => {
                this.researchInfrastructure = researchInfrastructure;
                console.log('Init view researchInfrastructure: ' , this.researchInfrastructure);
                this.filteredOperators = this.researchInfrastructure.researchInfrastructureOrganisations.filter(
                    ( organisation: ResearchInfrastructureOrganisation ) => organisation.isCoordinator !== true );
                this.filteredCoordinators = this.researchInfrastructure.researchInfrastructureOrganisations.filter(
                    ( organisation: ResearchInfrastructureOrganisation ) => organisation.isCoordinator === true );
            } );
    }

    // return the url of the current window
    public getUrl() {
        return window.location.href;
    }

    /**
     * call edit-view of researchInfrastructure
     */
    public edit() {
        this.navigationService.setLastBackUrl(window.location.href); // remember last back URL
        this.router.navigate([`/researchInfrastructure/edit/${this.researchInfrastructure.id}`],
            { queryParams: { showSearchButton: true, showBackButton: true } });
    }

    /* get all containing publication Ids for searchConfiguration searchEntityIds */
    public getPublicationIdsAsString(): string {
        if (this.researchInfrastructure.publications) {
            return this.researchInfrastructure.publications.map(p => p.id).join(',');
        }
        return undefined;
    }

    /* leaving page action use onBeforeNavigate set last back url with navigationService */
    public onBeforeNavigate() {
        this.navigationService.setLastBackUrl(window.location.href);
    }
}
